import { render, staticRenderFns } from "./Ventures.vue?vue&type=template&id=291db785&scoped=true"
import script from "./Ventures.vue?vue&type=script&lang=js"
export * from "./Ventures.vue?vue&type=script&lang=js"
import style0 from "./Ventures.vue?vue&type=style&index=0&id=291db785&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291db785",
  null
  
)

export default component.exports